import { useState, useEffect, useCallback } from "react";
import { ITEMS_PER_PAGE } from "../../../constants";
import { showErrorToast, getAllDuplicateSubmissions } from "../../../helpers";
import { getSelectedJournalIds } from "../../../helpers/journals";

const useScreenedManuscripts = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [fetchParams, setFetchParams] = useState({
    currentPage: 0,
    searchTerm: "",
  });

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(false);

      const selectedJournalIds = await getSelectedJournalIds();

      const { currentPage, searchTerm } = fetchParams;
      let reports, total;
      ({ data: { reports = [], total = 0 } = {} } =
        await getAllDuplicateSubmissions(
          currentPage * ITEMS_PER_PAGE + 1,
          ITEMS_PER_PAGE,
          searchTerm,
          selectedJournalIds
        ));
      setData(reports);
      setPageCount(Math.ceil(total / ITEMS_PER_PAGE));
    } catch (err) {
      showErrorToast();
      setError(true);
    } finally {
      setIsLoading(false);
    }
  }, [fetchParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const updateFetchParams = (newParams) => {
    setFetchParams((prev) => ({
      ...prev,
      ...newParams,
      currentPage:
        newParams.currentPage !== undefined
          ? newParams.currentPage
          : prev.currentPage,
    }));
  };

  return {
    data,
    error,
    pageCount,
    currentPage: fetchParams.currentPage,
    searchTerm: fetchParams.searchTerm,
    setSearchTerm: (term) =>
      updateFetchParams({ searchTerm: term, currentPage: 0 }),
    setCurrentPage: (page) => updateFetchParams({ currentPage: page }),
    fetchData,
    isLoading,
  };
};

export default useScreenedManuscripts;
